import { useLoaderData } from "react-router";
import DocumentForm from "./DocumentForm";

export default function EditEquipmentDocument() {
  const document = useLoaderData();
  return <DocumentForm document={document} />;
}
